<template>
  <div>
    <OrderArticle
        :article="article"
        :disabled="disabled"
        :is-complete="isComplete"
        class="-highlighted"
    />

    <EntityArticle
      v-for="data in orderSuggestion"
      :key="data.id"
      :data="data"
      :disabled="disabled"
      :is-complete="isComplete"
    />
  </div>
</template>

<script>
import OrderArticle from "@/components/SmartLogistics/Warehouse/Partials/OrderArticle.vue";
import {internalOrderMixin} from "@/mixins/SmartLogistics/ModelC/internalOrder";
import EntityArticle from "@/components/SmartLogistics/Warehouse/Partials/EntityArticle.vue";

export default {
  name: 'OrderArticleWithResidents',
  components: {EntityArticle, ArticleResident: EntityArticle, OrderArticle},
  mixins: [internalOrderMixin],

  props: {
    article: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isComplete: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    orderSuggestion() {
      return this.order.order_suggestion.filter(i => i.quantity > 0 && i.artikelNrLAG === this.article.internalID)
    },
  },
}
</script>